<template>
  <div class="assessSuccess">
    <nav-bar title="评价" ></nav-bar>
    <van-cell is-link class="project">
      <template #title>
        <span class="number">{{ order.sn }}</span>
        <p class="name">{{ order.projectName }}</p>
        <van-tag color="#FF9500">{{ order.workTypeName }}</van-tag>
      </template>
    </van-cell>
    <van-cell title="下单时间" :value="order.passengerName+order.passengerMobile" />
    <van-cell is-link class="project">
      <template #title>
        <span>订单车辆</span>
        <van-tag class="tag" color="#9EA0A5">{{ order.carTypeName }}</van-tag>
      </template>
      <template #right-icon>
        <van-tag class="tagRight" color="rgba(255,149,0,0.1)">{{
          order.driverName
        }}</van-tag>
        <span class="spanRight">{{ order.carNumber }}</span>
      </template>
    </van-cell>
    <van-cell title="下单时间" :value="order.startTime" />
    <van-cell title="用车时间" :value="order.useCarTime" />
  <div class="evaluation" v-for="(item,index) in evaluation" :key="index">
        <div class="happening">
      <p>乘车情况</p>
   <span > {{item.evaluationList.join(",")}}  </span>
    </div>
    <div class="happening">
      <p>服务态度评价</p>
      {{item.active}}
    </div>
    <div class="happening">
      <p>驾驶技术评价</p>
         {{item.technicalEvaluation}}
    </div>
    <div class="happening">
      <p>备注</p>
         {{remarks}}
    </div>
  </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import { Cell, Tag, Dialog } from "vant";
export default {
  name: "assessEvaluationDetails",
  data() {
    return {
      show: 0,
      order: [],
      evaluation:"",
    //   备注
      remarks:"",
      accountid: localStorage.getItem("accountUid"),
      sn: [],
      icon: {
        active: require("@/assets/03.gif"),
        inactive: require("@/assets/12.png"),
        active2: require("@/assets/13.gif"),
        inactive2: require("@/assets/05.png"),
        active3: require("@/assets/13.gif"),
        inactive3: require("@/assets/07.gif"),
      },
      curId: 0,
    };
  },
  created() {
    this.sn = this.$route.params.sn;
    this.orderDetail();

  },
  mounted() {},
  methods: {
    // 订单详情
    orderDetail() {
      this.$axios
        .get(
          `/vedm/orderCommonApp/getOrderDetail/${this.sn}/${this.accountid}`,
          {
            headers: {
              Authorization: localStorage.getItem("token"), //token换成从缓存获取
            },
          }
        )
        .then((res) => {
        //  评价
         this.evaluation= JSON.parse(res.data.data.serviceEvaluation.evaluationList)  
        // 备注
         this.remarks=res.data.data.remarks
         this.order = res.data.data;
        }).catch(function (error) {
			  console.log(error)
			   window.app.showReLoginDialog()
		});;
    },
  },
  components: {
    NavBar,
    "van-cell": Cell,
    "van-tag": Tag,
    [Dialog.Component.name]: Dialog.Component,
  },
};
</script>
<style scoped lang="less">
.evaluation{
    font-size: 15px;
}
.order {
  margin-left: 15px;
  display: flex;
  justify-content: space-between;
  background-color: white;
  font-size: 12px;
}
.assessSuccess {
  background: rgba(247, 247, 247, 1);

  .project {
    align-items: center;

    .number {
      display: block;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
    }

    .name {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(33, 37, 41, 1);
      margin: 0;
    }

    .tag {
      margin-left: 10px;
    }

    .tagRight {
      background: rgba(255, 149, 0, 0.1);
      border-radius: 2px;
      border: 1px solid rgba(255, 149, 0, 1);
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 149, 0, 1);
      margin-right: 5px;
    }

    .spanRight {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
    }
  }

  .happening {
    width: 375px;
    background: rgba(255, 255, 255, 1);
    padding: 15px;
    margin-bottom: 12px;

    p {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      margin: 0;
      margin-bottom: 20px;
    }

    .div {
      width: 104px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 14px;
      border: 1px solid rgba(232, 233, 235, 1);
      margin: 0 auto;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      float: left;
      margin-left: 30px;
    }

    .options {
      width: 345px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 20px;
    }

    .item {
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 6px;
      padding: 0 20px;
      border: 1px solid rgba(232, 233, 235, 1);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(98, 104, 112, 1);
      margin-top: 10px;
    }
  }
}
</style>
